// extracted by mini-css-extract-plugin
module.exports = {"slide":"ProductSlider-module--slide--19k22","slider":"ProductSlider-module--slider--2_4BF"};